module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cip-break"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Copyright © 2017 by Princeton University Press")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Illustrations © 2017 by Natalie Frank")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Requests for permission to reproduce material from this work should be sent to Permissions, Princeton University Press")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_c('i', [_vm._v("Grateful acknowledgment is made for permission to reprint the following material:")])]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Do-All Ax,” from "), _c('i', [_vm._v("Terrapin’s Pot of Sense")]), _vm._v(" by Harold Courlander. Copyright 1957, 1985 by Harold Courlander. Reprinted by permission of The Emma Courlander Trust.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Guru and His Disciple,” from "), _c('i', [_vm._v("A Flowering Tree and Other Oral Tales from India")]), _vm._v(", by A. K. Ramanujan, with a Preface by Stuart Blackburn and Alan Dundes (Berkeley: University of California Press, 1997). Copyright © 1997 by the Regents of the University of California.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The High Sheriff and His Servant,” from "), _c('i', [_vm._v("Dog Ghosts and Other Texas Negro Folk Tales")]), _vm._v(", by J. Mason Brewer (Austin: University of Texas Press, 1958), pp. 20–21. Copyright © 1958, renewed 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“Krabat,” from "), _c('i', [_vm._v("Sorbische Volkserzählungen")]), _vm._v(", edited by Jerzy Slizinski (Berlin: Akademie-Verlag, 1964), pp. 45–50. Copyright © DeGruyter.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Magician’s Apprentice” by Farīd al-Dīn "), _c('span', {
    staticClass: "times"
  }, [_vm._v("ʿ")]), _vm._v("Attār, from "), _c('i', [_vm._v("The Ocean of the Soul: Man, the World and God in the Stories of Farīd al-Dīn "), _c('span', {
    staticClass: "times"
  }, [_vm._v("ʿ")]), _vm._v("Attār")]), _vm._v(", by Hellmut Ritter, trans. John O’Kane with Bernd Ratke (Leiden: Brill, 2003), pp. 640–41.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Man and His Son” by Corinne Saucier, from "), _c('i', [_vm._v("Folk Tales from Louisiana")]), _vm._v(" (Baton Rouge, LA: Claitor’s Publisher, 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Mojo,” from "), _c('i', [_vm._v("Negro Folktales in Michigan")]), _vm._v(", collected and edited by Richard M. Dorson (Cambridge, MA: Harvard University Press, 1956). Copyright © 1956 by the President and Fellows of Harvard College.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_c('i', [_vm._v("The Sorcerer’s Apprentice")]), _vm._v(", by Richard Rostron, illustr. Frank Lieberman (New York: William Morrow, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("“The Two Magicians,” from "), _c('i', [_vm._v("Tales from the French Folklore of Missouri")]), _vm._v(", by Joseph Médard Carrière (Evanston, IL: Northwestern University Press, 1937), pp. 91–96.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Published by Princeton University Press, 41 William Street, Princeton, New Jersey 08540")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("In the United Kingdom: Princeton University Press, 6 Oxford Street, Woodstock, Oxfordshire OX20 1TR")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://press.princeton.edu",
      "target": "_blank"
    }
  }, [_vm._v("press.princeton.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Jacket illustration by Natalie Frank")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Jacket and book design by Chris Ferrante")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("All Rights Reserved")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("ISBN 978-0-691-17265-1")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("British Library Cataloging-in-Publication Data is available")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("This book has been composed in Adobe Jenson with Latimer for display")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Printed on acid-free paper. ∞")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ecf0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright_page.vue
// module id = 66
// module chunks = 0